import React, { Fragment } from 'react';
import T from 'prop-types';
import SimpleFormat from '@16g/react-simple-format';
import { isNull } from 'lodash-es';
import { today, differenceInDays, isAfter, isSameOrBefore } from '../../../utils/date';

const VersionHistory = ({
  versions = [],
  averageReleaseInterval,
  formattedReleasedDate,
  formattedReleasedOnDate,
}) => {
  const releasedSubtitle = () => {
    if (!versions.length) return 'No version updates.';
    if (isNull(averageReleaseInterval) || versions.length === 1) return `Last version released ${differenceInDays(today(), versions[0].release_date)} days ago.`;

    return `Releasing updates every ${averageReleaseInterval} on average. Last update ${differenceInDays(today(), versions[0].release_date)} days ago.`;
  };

  const renderMainContent = data => (
    <Fragment>
      <div className="version-history-header">
        <h2 className="widget-title">Version History</h2>
        <h3 className="release-subtitle">{releasedSubtitle()}</h3>
      </div>

      <div className="versions-history-truncate">
        <div className="versions-history">
          {data.map(({
            description,
            version,
            formatted_release_date,
            release_date,
          }, i) => {
            const isEqualOrBeforeDates = isSameOrBefore(formattedReleasedOnDate, release_date);
            const isAfterNextDates = data[i + 1]
              && isAfter(formattedReleasedOnDate, data[i + 1].release_date);
            const isBeforeLastDates = data[data.length - 1]
              && isSameOrBefore(formattedReleasedOnDate, data[data.length - 1].release_date);
            const versionItem = (
              <div key={version} className="versions-history-item">
                <div className="versions-history-meta">
                  <span>{version}</span>
                  <span>{formatted_release_date}</span>
                </div>
                <SimpleFormat text={description} />
              </div>
            );
            const launchItem = (
              <div className="versions-history-item launched-item">
                <div className="versions-history-meta">
                  <span>Launched</span>
                  <span>{formattedReleasedDate}</span>
                </div>
              </div>
            );

            if (isEqualOrBeforeDates && isAfterNextDates) {
              return (
                <Fragment key={`${release_date + version} Launched`}>
                  {launchItem}
                  {versionItem}
                </Fragment>
                );
              } else if (i === data.length - 1 && isBeforeLastDates) {
                return (
                  <Fragment key={`${release_date + version} Launched last`}>
                    {launchItem}
                  </Fragment>
                );
              }
              return (
                <Fragment key={release_date + version}>
                  {versionItem}
                </Fragment>
              );
            },
          )}
        </div>
      </div>
    </Fragment>
  );

  return (
    <Fragment>
      <div className="widget-container about-page-version-history">
        {renderMainContent(versions)}
      </div>
    </Fragment>
  );
};

VersionHistory.propTypes = {
  averageReleaseInterval: T.string,
  formattedReleasedDate: T.string.isRequired,
  formattedReleasedOnDate: T.string.isRequired,
  versions: T.arrayOf(
    T.shape({
      description: T.string,
      release_date: T.string,
      version: T.string,
    }),
  ),
};

export default VersionHistory;
